import { apiAppointments } from 'tsx/constants/api';
import { get, put } from 'tsx/libs/genericAction';
import { createThunks } from 'tsx/libs/reduxUtils';

export const typePrefix = 'appointments-utilities';

const path = `${apiAppointments}/utilities/bulk-packages`;

const config = [
  { actionType: 'getEstimate', apiPath: path, method: get },
  { actionType: 'bulkUpdate', apiPath: path, method: put },
];

export const { getEstimate, bulkUpdate } = createThunks(typePrefix, config);
